import jwt from 'jsonwebtoken';
import React, {Component} from 'react';
import {FiAlignJustify} from 'react-icons/fi';
import {HashRouter, Redirect, Route, Switch} from 'react-router-dom';
import Sidebar from 'react-sidebar';
import styled from 'styled-components';
import {Centered1000} from './components/container/CenteredContainer';
import DataPrivacy from './components/DataPrivacy';
import {SidebarContent, sidebarStyles} from './components/SidebarContent';
import {ROLE_ADMIN, ROLE_EDITOR} from './constants/userConstants';
import ChangePasswordPage from './containers/ChangePasswordPage';
import LoginPage from './containers/LoginPage';
import MetaDataEdit from './containers/MetaDataEdit';
import MetaDatas from './containers/MetaDatas';
import UserEdit from './containers/UserEdit';
import UserNew from './containers/UserNew';
import UsersPage from './containers/UsersPage';
import WindowEdit from './containers/WindowEdit';
import WindowNew from './containers/WindowNew';
import WindowSearch from './containers/WindowSearch';
import WindowsPage from './containers/WindowsPage';
import GA from './utils/GoogleAnalytics';

class AuthRoute extends Component {
  shouldComponentUpdate({user, path}) {
    let oldUser = this.props.user;
    let newUserId = user && user._id;
    let oldUserId = oldUser && oldUser._id;
    return newUserId !== oldUserId || path !== this.props.path;
  }

  render() {
    let {component: Component, user, role, ...rest} = this.props;
    return (
      <Route
        {...rest}
        render={(props) => {
          let isAllowed = false;
          if (!role && user) {
            isAllowed = true;
          } else if (user) {
            if (user.role === ROLE_ADMIN) isAllowed = true;
            else isAllowed = user.role === role;
          }
          return isAllowed ? (
            <Component {...props} user={user} />
          ) : (
            <Redirect to={{pathname: '/login', state: {from: props.location}}} />
          );
        }}
      />
    );
  }
}

export function getUser() {
  let user;
  let token = localStorage.getItem('@wkoWindowStore:authToken');

  if (token) {
    token = token.replace('JWT ', '');
    user = jwt.decode(token);
    user.token = 'JWT ' + token;
  }
  return user;
}

const SidebarToggle = styled.div`
  position: fixed;
  left: 10px;
  top: 10px;
  width: 40px;
  height: 40px;
  background: ${(props) => props.theme.secondaryColor};
  line-height: 40px;
  text-align: center;
  color: white;
  cursor: pointer;
  z-index: 500;
  svg {
    margin-top: 5px;
  }
`;

export default class Navigation extends Component {
  constructor() {
    super();
    this.state = {sidebarOpen: false};
  }
  onSetSidebarOpen = (open) => {
    this.setState({sidebarOpen: open});
  };

  openSidebar = () => {
    this.setState({sidebarOpen: true});
  };
  closeSidebar = () => {
    this.setState({sidebarOpen: false});
  };

  render() {
    const user = getUser();
    return (
      <HashRouter>
        <div>
          {GA.init() && <GA.RouteTracker />}
          <Switch>
            <Route exact path="/reset-password/:token" component={ChangePasswordPage} />
            <Route exact path="/datenschutz" component={DataPrivacy} />
            <Route
              exact
              path="/login"
              render={(props) =>
                user ? (
                  <Redirect to={{pathname: '/windows', state: {from: props.location}}} />
                ) : (
                  <LoginPage {...props} rerender={() => this.setState({update: Date.now()})} />
                )
              }
            />
            <Sidebar
              sidebar={
                <div onClick={this.closeSidebar}>
                  <SidebarContent user={user} />
                </div>
              }
              open={this.state.sidebarOpen}
              onSetOpen={this.onSetSidebarOpen}
              styles={sidebarStyles}>
              <SidebarToggle onClick={this.openSidebar}>
                <FiAlignJustify size={30} />
              </SidebarToggle>
              <Centered1000>
                <Switch>
                  <AuthRoute user={user} exact path="/windows" component={WindowsPage} />
                  <AuthRoute user={user} role={ROLE_ADMIN} exact path="/users" component={UsersPage} />
                  <AuthRoute user={user} role={ROLE_ADMIN} exact path="/new/user" component={UserNew} />
                  <AuthRoute user={user} role={ROLE_ADMIN} exact path="/user/edit/:id" component={UserEdit} />
                  <AuthRoute user={user} role={ROLE_EDITOR} exact path="/new/window" component={WindowNew} />
                  <AuthRoute user={user} role={ROLE_EDITOR} exact path="/edit/window/:id" component={WindowEdit} />
                  <AuthRoute user={user} exact path="/search" component={WindowSearch} />
                  <AuthRoute user={user} role={ROLE_ADMIN} exact path="/metadatas" component={MetaDatas} />
                  <AuthRoute user={user} role={ROLE_ADMIN} exact path="/metadata/edit/:id" component={MetaDataEdit} />
                  <Redirect to="/windows" />
                </Switch>
              </Centered1000>
            </Sidebar>
          </Switch>
        </div>
      </HashRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Navigation.js